import useMenuItemsInsertStatement from '../../menuItems/useMenuItemsInsertStatement.mjs'
import extendNode from '../extendNode.mjs'
import {lintForCode, lintForDoc} from '../AR/lint.mjs'
import useArCatNode from '../_AR_CAT/useArCatNode.jsx'
import meta from './metaAlgRule.mjs'

export default () => {
    const ArCatNode = useArCatNode()
    const menuItemsInsertStatement = useMenuItemsInsertStatement()

    return extendNode(ArCatNode, {
        ...meta,

        canInsertStatement(map, node, statement) {
            return 'UE' === node.parent?.data.bizNodeType
        },

        getText(map, node) {
            if (/^(UE|UIALG)$/.test(node.parent?.data.bizNodeType)) {
                return '处理逻辑'
            }
            else {
                return ArCatNode.getText.call(this, map, node)
            }
        },

        async lintTree(map, node, type) {
            if ('UE' === node.parent?.data.bizNodeType) {
                ({
                    code: () => lintForCode(map, node),
                    doc: () => lintForDoc(map, node),
                })[type]?.()
            }
            else {
                await ArCatNode.lintTree.call(map, node)
            }
        },

        menuItemsInsertCommon(map, node) {
            const items = ArCatNode.menuItemsInsertCommon.call(this, map, node)

            if ('UE' === node.parent?.data.bizNodeType) {
                return [...items, ...menuItemsInsertStatement]
            }
            else {
                return items
            }
        },

        async _atOwnerPush(map, node, event) {
            event.stopPropagation()
            const d = await this._getPushData(map, node)
            event.detail.algList.push(d)
        },
    })
}
